import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, NavX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import PIContainer from "../shared/PIContainer/PIContainer";
import { HStack, VStack, XButton, XDiv, XImage, XText } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class PIDashboard extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PIDashboard.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  CheckPolicy = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Insurer/AllPolicies");
  }

  CheckClaim = () => {
    let {history} = this.props;
    NavX.Goto(history, "/Insurer/Claim");
  }

  renderQABtn(func, src, caption){
    return (
      <XButton onPress={func} width={237} height={237} m={10} padding={0}
        bgColor={ColorX.CSS("pureWhite")} shadow notInjectColor>
        <VStack fullWidth spacing={10}>
          <XDiv width={142} height={142} round={"50%"} p={36}
            bgColor={ColorX.CSS("Axit", 0.1)}>
            <XImage source={src} width={70} height={70}/>
          </XDiv>
          <XText color={ColorX.CSS("Active")} bold>
            {LocaleX.Parse(caption)}
          </XText>
        </VStack>
      </XButton>
    );
  }

  renderQuickActions(){
    return (
      <VStack fullWidth bgColor={ColorX.CSS("NotQuiteWhite")}
        p={16} pT={70} spacing={20}>
          <XText bold color={ColorX.CSS("Grass")} fontSize={32}>
            {LocaleX.Parse({
              EN: "Quick Actions",
              TC: "快速啟動"
            })}
          </XText>
        <HStack flexWrap="wrap" fullWidth>
          {this.renderQABtn(this.CheckPolicy, 
            "/Images/QA/checkpolicy.svg",
            {
              EN: "Check Policy",
              TC: "查詢保單"
            }
          )}
          {this.renderQABtn(this.CheckClaim, 
            "/Images/QA/checkclaim.svg",
            {
              EN: "Check Claim",
              TC: "查詢索償"
            }
          )}
        </HStack>
      </VStack>
    );
  }

  render(){
    return (
      <PIContainer>
        {this.renderQuickActions()}
      </PIContainer>
    );
  }

}

export default observer(PIDashboard);
